module.exports = __webpack_public_path__ + "static/media/speakersandpartnersDinner.3e11f597.jpeg";